import React from 'react';
import { useMergeCssClasses } from '../../../Utils/utils';

var PlusIcon = function PlusIcon(_ref) {
  var propClasses = _ref.classes;
  var classes = useMergeCssClasses(propClasses);
  return React.createElement("svg", {
    className: classes.root,
    xmlns: "http://www.w3.org/2000/svg",
    width: "46",
    height: "46",
    viewBox: "0 0 46 46"
  }, React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFF",
    strokeLinecap: "square",
    strokeWidth: "2",
    d: "M12.268 23h21.464M23 12.268v21.464"
  }));
};

export default PlusIcon;